/** Presentation-only formatting. Money is pence in, strings out; unknown stays a dash. */

const gbp = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 })
const gbpExact = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const DASH = '—'

export function money(pence: number | string | null | undefined): string {
  if (pence === null || pence === undefined || pence === '') return DASH
  const value = typeof pence === 'string' ? Number(pence) : pence
  if (!Number.isFinite(value)) return DASH
  return gbp.format(value / 100)
}

export function moneyExact(pence: number | string | null | undefined): string {
  if (pence === null || pence === undefined || pence === '') return DASH
  const value = typeof pence === 'string' ? Number(pence) : pence
  if (!Number.isFinite(value)) return DASH
  return gbpExact.format(value / 100)
}

/** Decimal pounds (model outputs are exact decimal strings in pounds). */
export function poundsExact(pounds: string | number | null | undefined): string {
  if (pounds === null || pounds === undefined || pounds === '') return DASH
  const value = typeof pounds === 'string' ? Number(pounds) : pounds
  if (!Number.isFinite(value)) return DASH
  return gbpExact.format(value)
}

export function percent(ratio: string | number | null | undefined, digits = 2): string {
  if (ratio === null || ratio === undefined || ratio === '') return DASH
  const value = typeof ratio === 'string' ? Number(ratio) : ratio
  if (!Number.isFinite(value)) return DASH
  return `${(value * 100).toFixed(digits)}%`
}

export function humanize(value: string | null | undefined): string {
  if (!value) return ''
  return value.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())
}

export function dateShort(iso: string | null | undefined): string | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' })
}

export function daysUntil(iso: string | null | undefined): number | null {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  const today = new Date()
  const utcToday = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())
  return Math.round((Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate()) - utcToday) / 86_400_000)
}

export function area(sqm: number | null | undefined, assumed = false): string {
  if (sqm === null || sqm === undefined) return 'Area unknown'
  return `${Number(sqm.toFixed(1)).toLocaleString('en-GB')} m²${assumed ? ' (assumed)' : ''}`
}

export function beds(n: number | null | undefined): string | null {
  if (n === null || n === undefined) return null
  return `${n} bed${n === 1 ? '' : 's'}`
}

export function photoVariant(url: string, variant: 'small' | 'medium' | 'full'): string {
  if (!url.startsWith('/media/')) return url
  const u = new URL(url, 'https://propalpha.invalid')
  u.searchParams.set('variant', variant)
  return `${u.pathname}${u.search}`
}
